const Menu = [
  { header: "Procesos SIMCE" },
  {
    title: "Busqueda de contratos",
    group: "apps",
    component: "Impresion",
    icon: "dashboard",
    name: "ProveedorImpresion",
  },
  { header: "Configuracion" },
  {
    title: "Panel de Contratos",
    group: "sistema",
    icon: "assignment",
    name: "PanelContratos",
  },
  // {
  //   title: 'Información Contrato',
  //   group: 'sistema',
  //   icon: 'dashboard',
  //   name: 'ConfigProveedor',
  // },
  // {
  //   title: 'Auditoria',
  //   group: 'sistema',
  //   icon: 'dashboard',
  //   name: 'Auditoria',
  // },
  {
    title: "Log de Aplicacion",
    group: "sistema",
    icon: "dashboard",
    name: "ApplicationLog",
  },
  {
    title: "Registro Civil",
    group: "sistema",
    icon: "dashboard",
    name: "RegistroCivil",
  },
  {
    title: "Videos Tutoriales",
    group: "sistema",
    icon: "dashboard",
    name: "VideosTutoriales",
  },
  {
    title: "Reporteria",
    group: "sistema",
    icon: "dashboard",
    name: "ReporteriaInfo",
  },
  {
    title: "Empadronamiento",
    group: "sistema",
    icon: "dashboard",
    name: "MecanizadoHistory",
  },
  {
    title: "Inf. de Pagos y Multas",
    group: "sistema",
    icon: "dashboard",
    name: "PagosMultasSelect",
  },
  // {
  //   title: "Ingreso de pagos",
  //   group: "sistema",
  //   icon: "dashboard",
  //   name: "PagosMultasSelectNuevo",
  // },
  // {
  //   title: "Ingreso de multas",
  //   group: "sistema",
  //   icon: "dashboard",
  //   name: "IngresoMultasSelectNuevo",
  // },
  {
    title: "Informacion Contractual",
    group: "sistema",
    icon: "dashboard",
    name: "AdministrativoContractual",
  },
  //dsoto 03-01-2023
  {
    title: "Gestion de Usuarios",
    group: "sistema",
    icon: "dashboard",
    name: "GestionUsuario",
  },
  //dsoto 03-01-2023
];
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export default Menu;
